import { Observable } from 'rxjs/Observable'
import { DataService } from 'core/data/service'

export class PbmService extends DataService {
    constructor() {
        super()
      }

    getIdTransacao(pbmAdmin){
        const options = {
            method: 'GET',
            url: '/pbm/idtransacao/' + pbmAdmin
        }
        
        return Observable
                .fromPromise(super.request(options));
    }

    preAutorizacao(preAutorizacao, pbmAdmin){
        const options = {
            method: 'POST',
            url: '/pbm/preautorizacao/' + pbmAdmin,
            data: preAutorizacao
        }
        
        return Observable
                .fromPromise(super.request(options));
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/components/modal/modal-pbm/pbm.service.js